module.exports = __webpack_public_path__ + "static/media/cc_icon-mc.bd8c7294.svg";